import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle, withHandlers, withState } from "recompose";
import { reduxForm, Field, SubmissionError } from "redux-form";
import {find, forEach, sortBy} from "lodash";
import { Radio } from "react-md";

import Dialog from "./DialogWrap";
import AutocompleteField from "../form/AutocompleteField";
import SelectField from "../form/SelectField";
import * as Validation from "../form/Validation";

import { resetForm } from "../../actions/appActions";
import {
  getOrganizationUsers,
  getTouchUsers,
  getTouchUsersWithFilter,
  bindOrganizationUserWithTouchUser,
  createOrganizationUser,
  getOrganizationUsersAdmin,
  getOrganizationUsersOwner,
  getOrganizationUsersUser,
  getOrganizationUserDetail
} from "../../actions/resourceActions";
import {array_utilities} from "../../Atollon/utilities/array_utilities";

const documentOptsValues = {
  USERS: "USERS",
  TEMPLATES: "TEMPLATES"
};

const documentOpts = [
  { label: "Existující", value: documentOptsValues.USERS },
  { label: "Nový", value: documentOptsValues.TEMPLATES }
];

const roleOpts = [
  { label: "Správce", value: "admin" },
  { label: "Vlastník", value: "owner" },
  { label: "Uživatel", value: "user" }
];

const getAllOrganizationUsers = (data) => {
    console.log('getting organization user?');
    if(data && data.organizationId)
    {
        console.log('getting organization user, YES, with id', data.organizationId);
        getOrganizationUsers(data.organizationId, ''); // all
    }
};

const OrganizationUserAdministration_Dialog = ({
  handleSubmit,
  data,
  getOrganizationUsers,
  getTouchUsers,
  getTouchUsersWithFilter,
  organizationUsers,
  touchUsers,
  change,
  organizationTemplates,
  usersTemplatesState,
  changeUsersTemplatesState,
  createOrganizationUser,
  fail
}) => {
  const optionsTouchUsers = [];

    getAllOrganizationUsers( data );
    getTouchUsersWithFilter( '' );

  if (touchUsers)
  {
      forEach(array_utilities.array_of_structs_locale_sort_by_array_of_field_names(touchUsers, ['name']), item =>
          optionsTouchUsers.push({
              label: item.name,
              value: item.id
          })
      );
      // console.log('optionsTouchUsers',touchUsers.length,optionsTouchUsers.length, optionsTouchUsers);
  }

  const optionsOrganizationUsers = [];

  if (organizationUsers) {
    forEach(array_utilities.array_of_structs_locale_sort_by_array_of_field_names(organizationUsers,['name']), item =>
      optionsOrganizationUsers.push({
        label: item.name,
        value: item.id
      })
    );
  }

  const optionsOrganizationTemplates = [];

  if (organizationTemplates) {
    forEach( array_utilities.array_of_structs_locale_sort_by_array_of_field_names( organizationTemplates, ['name']), item =>
      optionsOrganizationTemplates.push({
        label: item.name,
        value: item.id
      })
    );
  }

  // console.log('touchUsers', touchUsers);
  // console.log('optionsTouchUsers', optionsTouchUsers);
  // console.log('organizationUsers', organizationUsers);
  // console.log('organizationTemplates', organizationTemplates);

  return (
    <Dialog
      title="Přidat uživatele"
      name="OrganizationUserAdministration_Dialog"
      handleSubmit={handleSubmit}
      submitLabel="Potvrdit"
      onClose={data ? data.onClose : null}
    >
      <Radio
        id="OrganizationUserAdministration-radio-users"
        name="OrganizationUserAdministrationRadioUsers"
        className="radio-option"
        value={documentOpts[0].value}
        label={documentOpts[0].label}
        checked={usersTemplatesState === documentOpts[0].value}
        onClick={() => changeUsersTemplatesState(documentOpts[0].value)}
      />
      <Radio
        id="OrganizationUserAdministration-radio-templates"
        name="OrganizationUserAdministrationRadioTemplates"
        className="radio-option"
        value={documentOpts[1].value}
        label={documentOpts[1].label}
        checked={usersTemplatesState === documentOpts[1].value}
        onClick={() => changeUsersTemplatesState(documentOpts[1].value)}
      />
        {
              /*

              M: not working
              <Field
                component={AutocompleteField}
                label={(usersTemplatesState === documentOpts[1].value? "Uživatel touch": "Stávající uživatel touch") + " : AUTOCOMPLETE"}
                name="touchUser"
                data={optionsTouchUsers}
                onClick={(e, value) => {
                    getTouchUsers(value);
                }}
                onChange={(e, value) => {
                  getTouchUsers(value);
                }}
                onAutocomplete={value => {
                  if (find(touchUsers, u => u.id === value))
                    change("touchUser", find(touchUsers, u => u.id === value).name);
                }}
                validate={[Validation.required]}
              />

              M: works

              <Field
                  component={SelectField}
                  label={(usersTemplatesState === documentOpts[1].value? "Uživatel touch": "Stávající uživatel touch") + " : SELECT"}
                  name="touchUser"
                  menuItems={optionsTouchUsers}
                  validate={[Validation.required]}
                  onFocus={()=>{
                      getTouchUsersWithFilter();
                  }}
              />
          */
        <div>
              <Field
                  component={AutocompleteField}
                  label={(usersTemplatesState === documentOpts[1].value? "Uživatel touch": "Stávající uživatel touch")}
                  name="touchUser"
                  data={optionsTouchUsers}
                  onClick={(e, value) => {
                      console.log('CLICK getTouchUsersWithFilter',value);
                      getTouchUsersWithFilter(value);
                  }}
                  onFocus={(e, value) => {
                      console.log('FOCUS getTouchUsersWithFilter',value);
                      getTouchUsersWithFilter(value);
                  }}
                  onChange={(e, value) => {
                      getTouchUsersWithFilter(value);
                  }}
                  onAutocomplete={value => {
                      if (find(touchUsers, u => u.id === value))
                          change("touchUser", find(touchUsers, u => u.id === value).name);
                  }}
                  validate={[Validation.required]}
              />
        </div>
      }
      <Field
        component={SelectField}
        label="Role"
        name="role"
        menuItems={roleOpts}
        validate={[Validation.required]}
      />
      {usersTemplatesState === documentOptsValues.USERS ? (
        <div>
          <Field
            component={AutocompleteField}
            label="Uživatel organizace"
            name="organizationUser"
            data={optionsOrganizationUsers}
            onFocus={(e,value)=>{
                console.log('FOCUS getOrganizationUsers(',data.organizationId, value);
                getOrganizationUsers(data.organizationId, value);
            }}
            onChange={(e, value) => {
              //console.log('CHANGE getOrganizationUsers(',data.organizationId, value);
              getOrganizationUsers(data.organizationId, value);
            }}
            onAutocomplete={value => {
              if (find(organizationUsers, u => u.id === value))
                change(
                  "organizationUser",
                  find(organizationUsers, u => u.id === value).name
                );
            }}
            validate={[Validation.required]}
          />
        </div>
          /*
          M: does not work all the times !
          <Field
              component={SelectField}
              label={"Uživatel organizace : SELECT"}
              name="organizationUser"
              menuItems={optionsOrganizationUsers}
              validate={[Validation.required]}
              onFocus={()=>{
                  console.log('onFocus');
                  getAllOrganizationUsers( data );
              }}
          />
           */
      ) : (
        <Field
          component={SelectField}
          label="Šablona"
          name="template"
          menuItems={optionsOrganizationTemplates}
          validate={[Validation.required]}
        />
      )}
      {fail && <div className="flex-row error">{fail}</div>}
    </Dialog>
  );
};

export default compose(
  connect(
    ({
      dialog: { data },
      resource: { touchUsers, organizationUsers, organizationTemplates }
    }) => ({
      data,
      touchUsers,
      organizationUsers,
      organizationTemplates
    }),
    {
      getOrganizationUsers,
      getTouchUsers,
      getTouchUsersWithFilter,
      bindOrganizationUserWithTouchUser,
      createOrganizationUser,
      getOrganizationUsersAdmin,
      getOrganizationUsersOwner,
      getOrganizationUsersUser,
      resetForm,
      getOrganizationUserDetail
    }
  ),
  withState(
    "usersTemplatesState",
    "changeUsersTemplatesState",
    documentOptsValues.USERS
  ),
  withState("fail", "setFail", false),
  withHandlers({
        onSubmit: dialog => async (formData, dispatch, props) => {

              // debugger;

              const {
                data,
                bindOrganizationUserWithTouchUser,
                createOrganizationUser,
                usersTemplatesState,
                touchUsers,
                organizationUsers,
                organizationTemplates,
                setFail,
                getOrganizationUsersAdmin,
                getOrganizationUsersOwner,
                getOrganizationUsersUser,
                resetForm,
                getOrganizationUserDetail
              } = props;

              const { touchUser, organizationUser, template, role } = formData;

              let touchUserEmail = null;
              {
                  const selectedTouchUser = find(touchUsers, u => u.name === touchUser);
                  if( selectedTouchUser )
                  {
                      touchUserEmail = selectedTouchUser.id;
                  }
                  else
                  {
                      touchUserEmail = touchUser;
                  }

                  const validationError = Validation.email( touchUserEmail );
                  if( validationError )
                  {
                      throw new SubmissionError({
                          touchUser: "Chybný email nového Touch uživatele."
                      });
                  }
              }

              if (usersTemplatesState === documentOptsValues.USERS) {

                    //
                    //  add existing user to instance
                    //

                    const selectedOrganizationUser = find(
                        organizationUsers,
                        u => u.name === organizationUser
                    );

                    if (!selectedOrganizationUser) {
                        throw new SubmissionError({
                            organizationUser: "Uživatel neexistuje."
                        });
                    }

                    if (
                      await bindOrganizationUserWithTouchUser(
                          data.organizationId,
                          selectedOrganizationUser.id,
                          touchUserEmail,
                          role
                      )
                    ) {
                          getOrganizationUserDetail(data.organizationId, selectedOrganizationUser.id);
                          getOrganizationUserDetail(data.organizationId, touchUserEmail);
                          getOrganizationUsersAdmin(data.organizationId);
                          getOrganizationUsersOwner(data.organizationId);
                          getOrganizationUsersUser(data.organizationId);
                          console.log('OKKKKKK 1');
                          resetForm("OrganizationUserAdministrationForm");
                          dialog.closeDialog();
                    } else {
                          setFail("Provázání účtů se nezdařilo.");
                    }

              } else {

                    //
                    //  add new user to instance
                    //

                    if (!find(organizationTemplates, t => t.id === template)) {
                          throw new SubmissionError({
                            template: "Povinné"
                          });
                    }

                    // debugger;
                    let addNewUserParams = {};
                    addNewUserParams.templateId = find(organizationTemplates, t => t.id === template).id;
                    addNewUserParams.email = touchUserEmail;
                    addNewUserParams.username = touchUserEmail.match(/^[^@]+/g)[0]; // "nezadavat UserName jako Jmeno Prijmeni, ale jako cast e-mailove adresy (to pred zavinacem)"

                    const userId = await createOrganizationUser(data.organizationId, addNewUserParams);

                    if (userId) {
                          if (
                            await bindOrganizationUserWithTouchUser(
                              data.organizationId,
                              userId,
                              touchUserEmail,
                              role
                            )
                          ) {
                            getOrganizationUserDetail(data.organizationId, touchUserEmail);
                            getOrganizationUserDetail(data.organizationId, userId);
                            getOrganizationUsersAdmin(data.organizationId);
                            getOrganizationUsersOwner(data.organizationId);
                            getOrganizationUsersUser(data.organizationId);
                              console.log('OKKKKKK 2');
                            resetForm("OrganizationUserAdministrationForm");
                            dialog.closeDialog();
                          } else {
                            setFail("Provázání účtů se nezdařilo.");
                          }
                    } else {
                          setFail("Vytvoření uživatele se nezdařilo.");
                    }
              }
        }
  }),
    /*
  lifecycle({
      componentWillMount( input ) {
          const { data, match, getOrganizationUsers, getTouchUsers } = this.props;
              debugger;
          if(data) {
              let organizationId = data.organizationId;
              getOrganizationUsers(organizationId, ''); // all
              getTouchUsers(''); // all
          }

      }
  }),
  */
  reduxForm({
    form: "OrganizationUserAdministrationForm"
  })
)(OrganizationUserAdministration_Dialog);



// WEBPACK FOOTER //
// ./src/components/dialogs/OrganizationUserAdministration_Dialog.js